export default {
  MEDIA_QUERY_SMALL_MOBILE: 355,
  MEDIA_QUERY_TABLET: 720,
  MEDIA_QUERY_DESKTOP: 960,
}
